import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './writing.component.html',
  styleUrls: ['./writing.component.scss']
})
export class WritingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
